import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Movimentação',
  path: '/pessoal/pestipomovimentacao',
  name: 'pestipomovimentacao',
  component: () => import('@/views/pessoal/pestipomovimentacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMOVIMENTACAONOVO_MENU_1400701099],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Movimentação',
  path: '/pessoal/pestipomovimentacao/cadastro/:id?',
  parent: 'pestipomovimentacao',
  name: 'pestipomovimentacao_create',
  component: () => import('@/views/pessoal/pestipomovimentacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMOVIMENTACAONOVO_MENU_1400701099],
  },
  goesToMenu: true,
 },
]
